export default {"src":"/_next/static/media/google.f204236e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};